import React, { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { GlobalState } from "../../../../GlobalState";
import { TabTitle } from "../../../../util/titleChanger";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "./purchaseview.css";

function PurchaseView() {
  TabTitle("Product View");
  const { purchaseId } = useParams();
  const state = useContext(GlobalState);

  const [purchaseDetail] = state.purchaseAPI.purchaseDetail;
  const [id, setId] = state.purchaseAPI.id;

  const [allSuppliers] = state.supplierAPI.allSuppliers;
  const [productsList] = state.productAPI.productsList;

  const [values, setValues] = useState("");
  const [productValues, setProductValues] = useState([]);

  const printRef = useRef();

  useEffect(() => {
    setProductValues([]);
    if (purchaseId > 0) {
      setId(purchaseId);
      var today = new Date();
      var purchase_date = purchaseDetail.purchase_date
        ? purchaseDetail.purchase_date.substring(0, 10)
        : today.toISOString().substring(0, 10);

      setValues({
        ...values,
        invoice_no: purchaseDetail.invoice_no
          ? purchaseDetail.invoice_no.toUpperCase()
          : "",
        total_amount: purchaseDetail.total_amount
          ? purchaseDetail.total_amount
          : "",
        quantity: purchaseDetail.quantity ? purchaseDetail.quantity : "",
        purchase_date:
          purchase_date === undefined
            ? today.toISOString().substring(0, 10)
            : purchase_date.substring(0, 10),
        description: purchaseDetail.description
          ? purchaseDetail.description
          : "",
        supplierName: purchaseDetail.supplier
          ? purchaseDetail.supplier.first_name +
            " " +
            purchaseDetail.supplier.last_name
          : "",
      });

      purchaseDetail.purchase_products
        ? purchaseDetail.purchase_products.map((product) => {
            setProductValues((products) => {
              return [
                ...products,
                {
                  productId: product.product.id,
                  productName: product.product.name,
                  quantity: product.quantity,
                  purchase_price: product.purchase_price,
                  selling_price: product.selling_price,
                },
              ];
            });
          })
        : setProductValues([]);
    }
  }, [id, purchaseId, allSuppliers, purchaseDetail, productsList]);

  const handlePrint = () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    // 📝 Title & Basic Info
    doc.setFontSize(16);
    doc.text(`Invoice No: ${values.invoice_no}`, 20, 20);
    doc.setFontSize(12);
    doc.text(`Date: ${values.purchase_date}`, 20, 30);
    doc.text(`Supplier: ${values.supplierName}`, 20, 40);
    doc.text(`Total Amount: Rs. ${values.total_amount}`, 20, 50);
    doc.text(`Description: ${values.description}`, 20, 60);

    // 📝 Add Table
    autoTable(doc, {
      startY: 70,
      head: [["Product Name", "Qty", "Purchase Price", "Selling Price"]],
      body: productValues.map((prod) => [
        prod.productName,
        prod.quantity,
        "Rs. " + prod.purchase_price,
        "Rs. " + prod.selling_price,
      ]),
    });

    // 📌 Add Signature & Date at Bottom
    const bottomMargin = 30;
    const signatureY = pageHeight - bottomMargin;

    doc.text("Authorized Signature:", 20, signatureY);
    doc.line(20, signatureY + 5, 80, signatureY + 5);

    const dateX = pageWidth - 60;
    doc.text(
      `Date: ${new Date().toISOString().substring(0, 10)}`,
      dateX,
      signatureY
    );

    // 🖨️ Open PDF & Print
    doc.autoPrint(); // Auto trigger print
    window.open(doc.output("bloburl"), "_blank"); // Open in new tab for printing
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const pageHeight = doc.internal.pageSize.height;
    const pageWidth = doc.internal.pageSize.width;

    doc.text(`Invoice No: ${values.invoice_no}`, 20, 20);
    doc.text(`Date: ${values.purchase_date}`, 20, 30);
    doc.text(`Supplier: ${values.supplierName}`, 20, 40);
    doc.text(`Total Amount: Rs. ${values.total_amount}`, 20, 50);
    doc.text(`Description: ${values.description}`, 20, 60);

    // 📝 Add Table
    autoTable(doc, {
      startY: 70,
      head: [["Product Name", "Qty", "Purchase Price", "Selling Price"]],
      body: productValues.map((prod) => [
        prod.productName,
        prod.quantity,
        "Rs. " + prod.purchase_price,
        prod.selling_price,
      ]),
    });

    const bottomMargin = 30;
    const signatureY = pageHeight - bottomMargin;

    doc.text("Authorized Signature:", 20, signatureY);
    doc.line(20, signatureY + 5, 80, signatureY + 5);

    const dateX = pageWidth - 60;
    doc.text(
      `Date: ${new Date().toISOString().substring(0, 10)}`,
      dateX,
      signatureY
    );

    doc.save(`Purchase_${values.invoice_no}.pdf`);
  };

  return (
    <div className="main-container-purchase" ref={printRef}>
      <h1>{values.invoice_no}</h1>
      <h3>{values.purchase_date}</h3>
      <div>
        <div className="left-main-container">
          <div className="quantity">
            Quantity : <span>{values.quantity}</span>
          </div>
          <div className="supplier">
            Supplier : <span>{values.supplierName}</span>
          </div>
          <div className="total">
            Total Amount : <span>Rs. {values.total_amount}</span>
          </div>
          <div className="description">
            Description : <span>{values.description}</span>
          </div>
        </div>
        <div className="right-main-container">
          <table>
            <thead>
              <tr>
                <th>Product Name</th>
                <th>Qty</th>
                <th>Purchase price</th>
                <th>Selling Price</th>
              </tr>
            </thead>
            <tbody>
              {productValues.map((product) => (
                <tr key={product.productId}>
                  <td>{product.productName}</td>
                  <td>{product.quantity}</td>
                  <td>{product.purchase_price}</td>
                  <td>{product.selling_price}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="print-button">
        <button className="add_new" onClick={handlePrint}>Print</button>
        <button className="add_new" onClick={handleDownloadPDF}>Download PDF</button>
      </div>
    </div>
  );
}

export default PurchaseView;
